import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../services/auth';
import './Auth.css';

export default function Login() {
  const [form,    setForm]    = useState({ email: '', password: '' });
  const [error,   setError]   = useState('');
  const [loading, setLoading] = useState(false);
  const [forgot,  setForgot]  = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotMsg,   setForgotMsg]   = useState('');
  const [forgotErr,   setForgotErr]   = useState('');
  const [forgotLoading, setForgotLoading] = useState(false);
  const { login }  = useAuth();
  const navigate   = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid email or password.');
    } finally { setLoading(false); }
  };

  const handleForgot = async e => {
    e.preventDefault();
    setForgotErr(''); setForgotLoading(true);
    try {
      const res = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: forgotEmail }),
      });
      const data = await res.json();
      if (res.ok) {
        setForgotMsg('Password reset link sent to ' + forgotEmail + '. Check your inbox.');
      } else {
        setForgotErr(data.error || 'Something went wrong. Try again.');
      }
    } catch (err) {
      setForgotErr('Network error. Please try again.');
    } finally { setForgotLoading(false); }
  };

  if (forgot) return (
    <div className="auth-page">
      <div className="auth-bg"><div className="auth-grid" /><div className="auth-orb orb1" /><div className="auth-orb orb2" /></div>
      <div className="auth-card">
        <div className="auth-logo"><span className="auth-logo-icon">⬡</span><span className="auth-logo-text">CloudUnify</span></div>
        <h1 className="auth-title">Reset Password</h1>
        <p className="auth-subtitle">Enter your email to receive a reset link</p>
        {forgotMsg && <div className="auth-success">✅ {forgotMsg}</div>}
        {forgotErr && <div className="auth-error">⚠ {forgotErr}</div>}
        {!forgotMsg && (
          <form onSubmit={handleForgot}>
            <div className="form-group">
              <label>Email address</label>
              <input className="form-control" type="email" placeholder="you@example.com"
                value={forgotEmail} onChange={e => setForgotEmail(e.target.value)} required />
            </div>
            <button className="btn btn-primary btn-lg" style={{ width:'100%' }} type="submit" disabled={forgotLoading}>
              {forgotLoading ? 'Sending...' : 'Send Reset Link →'}
            </button>
          </form>
        )}
        <p className="auth-link" style={{ marginTop:20 }}>
          <button onClick={() => { setForgot(false); setForgotMsg(''); setForgotErr(''); }}
            style={{ background:'none', border:'none', color:'var(--accent)', cursor:'pointer', fontSize:14 }}>
            ← Back to Sign In
          </button>
        </p>
      </div>
    </div>
  );

  return (
    <div className="auth-page">
      <div className="auth-bg"><div className="auth-grid" /><div className="auth-orb orb1" /><div className="auth-orb orb2" /></div>
      <div className="auth-card">
        <div className="auth-logo"><span className="auth-logo-icon">⬡</span><span className="auth-logo-text">CloudUnify</span></div>
        <h1 className="auth-title">Welcome back</h1>
        <p className="auth-subtitle">Sign in to your multi-cloud platform</p>
        {error && <div className="auth-error">⚠ {error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email address</label>
            <input className="form-control" type="email" placeholder="you@example.com"
              value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input className="form-control" type="password" placeholder="••••••••"
              value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required />
          </div>
          <div className="auth-forgot">
            <button type="button" onClick={() => setForgot(true)}>Forgot password?</button>
          </div>
          <button className="btn btn-primary btn-lg" style={{ width:'100%' }} disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In →'}
          </button>
        </form>
        <p className="auth-link">Don't have an account? <Link to="/register">Create one →</Link></p>
      </div>
    </div>
  );
}
